<div *ngIf="shouldShow" class="px-6 pt-4">
  <div
    class="flex flex-wrap items-center justify-between gap-4 rounded-lg border px-4 py-3 text-sm"
    [ngClass]="isExpired ? 'border-red-200 bg-red-50 text-red-800' : 'border-yellow-200 bg-yellow-50 text-yellow-800'">
    <div class="flex flex-col">
      <!-- Title -->
      <span class="font-semibold" *ngIf="isExpired">
        {{ 'shared.phaseRenewal.banner.expiredTitle' | translate }}
      </span>
      <span
        class="font-semibold"
        *ngIf="!isExpired"
        [innerHTML]="'shared.phaseRenewal.banner.expiringTitle' | translate: { days: currentPhase?.daysRemaining }">
      </span>

      <!-- Body line — keeps the banner compact on desktop but still readable. -->
      <span class="text-xs opacity-80" *ngIf="isExpired">
        {{ 'shared.phaseRenewal.banner.expiredBody' | translate }}
      </span>
    </div>

    <!-- CTA: disabled label when a request is already pending, otherwise clickable. -->
    <button
      *ngIf="!pendingRequest"
      type="button"
      pButton
      class="p-button-sm"
      [ngClass]="isExpired ? 'p-button-danger' : 'p-button-warning'"
      [label]="'shared.phaseRenewal.banner.requestRenewal' | translate"
      (click)="onRequestRenewal()"></button>

    <span *ngIf="pendingRequest" class="rounded-full bg-white/60 px-3 py-1 text-xs font-medium">
      {{ 'shared.phaseRenewal.banner.pendingRequest' | translate }}
    </span>
  </div>
</div>

<!-- Shared sales-contact modal handles the form + submission. -->
<app-sales-contact-modal
  [visible]="showSalesModal"
  (closed)="onSalesModalClosed()"
  (submitted)="onSalesRequestSubmitted()"></app-sales-contact-modal>
